/**
 * @file shell-rail.ts
 * @brief Shared AdminShell content-rail classes (Browserbase-style frame).
 *
 * @details
 * Centered ~1280px column. Vertical guides sit on the max-width edges
 * (`ShellRailGuides`). Main content uses the max-width rail **without**
 * horizontal padding so GridBlock pages and plain pages share the same
 * width — earlier shell `px-*` + optional `gridPageBleed` cancels made
 * some pages flush and others inset.
 *
 * Topbar uses the same unpadded max-width rail as main content (`shellRailMaxClass`)
 * so GridBlock chrome aligns with page grids. Footer branding row still uses
 * `shellRailClass` (padded).
 *
 * @author DES
 * @date 29-07-2026
 * @updated 29-07-2026 — topbar unpadded rail for GridBlock chrome
 * @updated 20-10-2026 — the Mac app is back on the centred 80rem rail (DES).
 * @updated 19-10-2026 — width cap = `--shell-rail-max` (index.css): 80rem on
 *   the web, none in the Mac app (`html.desktop-app`), so the app fills its
 *   window (DES 19-10-2026).
 */

/** Padded rail — footer (and legacy padded chrome). */
export const shellRailClass = "mx-auto w-full max-w-[var(--shell-rail-max)] px-4 md:px-6";

/** Max width only — main outlet, topbar GridBlock, guide positioning. */
export const shellRailMaxClass = "mx-auto w-full max-w-[var(--shell-rail-max)]";

/**
 * Overlays (mega menu, sheets / forms, Ask, ⌘K): always the centred 80rem
 * column, also in the full-width Mac app. Stretched across a big window they
 * looked wrong (DES 19-10-2026).
 */
export const shellOverlayMaxClass = "mx-auto w-full max-w-[80rem]";

/**
 * Optional horizontal pad for non-grid pages that need breathing room
 * inside the (now unpadded) main rail.
 */
export const shellContentPadClass = "px-4 md:px-6";
